import apiClient from './apiConfig';

const adsApi = {
  // Get all ads
  getAllAds: async () => {
    try {
      const response = await apiClient.get('/ads');
      return response.data;
    } catch (error) {
      console.error('Error fetching ads:', error);
      throw error;
    }
  },

  // Get ads by visibility
  getAdsByVisibility: async (isHide) => {
    try {
      const response = await apiClient.get(`/ads?hide=${isHide}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ads by visibility:', error);
      throw error;
    }
  },

  // Get single ad by ID
  getAdById: async (id) => {
    try {
      const response = await apiClient.get(`/ads/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ad:', error);
      throw error;
    }
  },

  // Create new ad
  createAd: async (adData) => {
    try {
      const response = await apiClient.post('/ads', adData);
      return response.data;
    } catch (error) {
      console.error('Error creating ad:', error);
      throw error;
    }
  },

  // Update ad
  updateAd: async (id, adData) => {
    try {
      const response = await apiClient.put(`/ads/${id}`, adData);
      return response.data;
    } catch (error) {
      console.error('Error updating ad:', error);
      throw error;
    }
  },

  // Delete ad
  deleteAd: async (id) => {
    try {
      const response = await apiClient.delete(`/ads/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting ad:', error);
      throw error;
    }
  }
};

export default adsApi;
